export const CAKE_BNB_LP_MAINNET = '0xf3b6cda12ca69b7c418116d8c70825ee3db420cd'
